angular.module('core').filter('levelTiny', [
    function() {
        return function(levelId, levelName) {
            if(_.isString(levelId)) {
                levelId = parseInt(levelId);
            }

            if( _.isNaN(levelId) || _.isUndefined(levelId) ) {
                return '';
            }

            switch (levelId) {
                case -1:
                    return "PRE-K";
                case 0:
                    return "K";
                case 8:
                    if (levelName && levelName.toLowerCase() === 'pre-algebra') {
                        return 'PRE-ALG';
                    }

                    return 8;
                case 9:
                    return "ALG";
                case 1001:
                    // 1001 is the code for "other"
                    return "";
                default:
                    return levelId;
            }
        };
    }
]);
